import { getConfig } from 'common/helpers/configHelper';

const API_GRAPHQL_URI = '/graphql';
const API_PUBLIC_URI = '/public';
const API_REST_URI = '/v2';

/**
 * Gets URL of CPanel graphql api
 * @return {string}
 */
export function getGraphQlApiUrl() {
  const { cpanelBackendUri } = getConfig();
  if (!cpanelBackendUri) {
    throw new Error('CPanel backend URI is undefined!');
  }
  return `${cpanelBackendUri}${API_GRAPHQL_URI}`;
}

/**
 * Gets URL of CPanel public api
 * @return {string}
 */
export function getPublicApiUrl() {
  const { cpanelBackendUri } = getConfig();
  if (!cpanelBackendUri) {
    throw new Error('CPanel backend URI is undefined!');
  }
  return `${cpanelBackendUri}${API_PUBLIC_URI}`;
}

export function getRestApiUrl() {
  const { cpanelBackendUri } = getConfig();
  if (!cpanelBackendUri) {
    throw new Error('CPanel backend URI is undefined!');
  }
  return `${cpanelBackendUri}${API_REST_URI}`;
}

export const getWsUrl = () => {
  const { cpanelBackendUri } = getConfig();
  if (!cpanelBackendUri) {
    throw new Error('CPanel backend URI is undefined!');
  }

  // TODO: properly parse the ws URI
  return `${cpanelBackendUri.replace('http', 'ws').replace('/api', '')}/user_socket`;
};
